var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",style:({ background: _vm.bgColor || 'transparent' })},[_c('div',{staticClass:"huisuiyunfont",on:{"click":_vm.handleBack}},[_vm._v(_vm._s('\ue670'))]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.headerTitle))]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }